import {combineReducers} from 'redux';

import faq from './stores/faq';
import config from './stores/config';
import payflow from './stores/payflow';
import profile from './stores/profile';
import services from './stores/services';
import payments from './stores/payments';
import currency from './stores/currency';
import countries from './stores/countries';

const rootReducer = combineReducers({
  faq,
  config,
  payflow,
  profile,
  services,
  payments,
  currency,
  countries
});

export default rootReducer
